import $ from 'jquery'
import env from 'src/../env.js'
import moment from 'moment'

module.exports = {
  scrollToElementByErrorBag (errorBag) {
    if (errorBag.errors.length > 0) {
      let name = errorBag.errors[0].field
      setTimeout(() => {
        this.scrollToElementByName(name)
      }, 0)
    }
  },
  scrollToElementByName (name) {
    let element = $("[name='" + name + "-display']")
    if (element.length === 0) {
      element = $("[name='" + name + "']")
    }
    if (element.length > 0) {
      $(window).scrollTop(element.offset().top - 100)
      let elementTab = element.closest('.box-collapse')
      if (!elementTab.find('div.panel-collapse').hasClass('in')) {
        elementTab.children('div').eq(0).click()
      }
      element.focus()
    }
  },
  focusTab (tabno) {
    let elementTab = $('.accordion').find('div.box-collapse').eq(parseInt(tabno) - 1)
    if (!elementTab.find('div.panel-collapse').hasClass('in')) {
      elementTab.children('div').eq(0).click()
    }
  },
  getAdditionalYear () {
    const user = JSON.parse(window.localStorage.getItem(env.site + '_currentUser'))
    let additionalYear = typeof user.additional_year !== 'undefined' ? user.additional_year : '0'
    return additionalYear
  },
  getDateOutput (dateInput) {
    if (typeof dateInput === 'string' && dateInput.trim() !== '') {
      let additionalYear = this.getAdditionalYear()
      let objDate = moment(dateInput, 'DDMMYYYY')
      if (objDate.isValid()) {
        let vDay = objDate.format('DD')
        let vMonth = objDate.format('MM')
        let vYear = parseInt(objDate.format('YYYY')) + parseInt(additionalYear)
        return vDay + '/' + vMonth + '/' + vYear
      } else {
        return dateInput
      }
    } else {
      return dateInput
    }
  },
  getDateTimeOutput (dateInput) {
    if (typeof dateInput === 'string' && dateInput.trim() !== '') {
      let additionalYear = this.getAdditionalYear()
      let arrDate = dateInput.split(' ')
      dateInput = arrDate[0] || ''
      let timeInput = (arrDate[1]) ? ' ' + arrDate[1] : ''
      dateInput = dateInput.replace(/\//g, '')
      let objDate = moment(dateInput, 'DDMMYYYY')
      if (objDate.isValid()) {
        let vDay = objDate.format('DD')
        let vMonth = objDate.format('MM')
        let vYear = parseInt(objDate.format('YYYY')) + parseInt(additionalYear)
        return vDay + '/' + vMonth + '/' + vYear + timeInput
      } else {
        return dateInput
      }
    } else {
      return dateInput
    }
  },
  getDateInput (dateInput) {
    if (typeof dateInput === 'string' && dateInput.trim() !== '') {
      let additionalYear = this.getAdditionalYear()
      dateInput = dateInput.replace(/\//g, '')
      let vDay = dateInput.substr(0, 2)
      let vMonth = dateInput.substr(2, 2)
      let vYear = dateInput.substr(4, 4)
      vYear = parseInt(vYear) - parseInt(additionalYear)
      return moment(vDay + vMonth + vYear, 'DDMMYYYY').format('DD/MM/YYYY')
    } else {
      return dateInput
    }
  },
  getYearOutput (yearInput) {
    let additionalYear = this.getAdditionalYear()
    return (yearInput !== '' && parseInt(yearInput) >= 0) ? (parseInt(yearInput) + parseInt(additionalYear)) : yearInput
  },
  getYearInput (yearInput) {
    let additionalYear = this.getAdditionalYear()
    return (yearInput !== '' && parseInt(yearInput) >= 0) ? (parseInt(yearInput) - parseInt(additionalYear)) : yearInput
  },
  getYearRangeOutput (yearInput) {
    if (typeof yearInput === 'string' && yearInput.trim() !== '') {
      let arrYear = yearInput.split('-')
      for (let i in arrYear) {
        arrYear[i] = this.getYearOutput(arrYear[i].trim())
      }
      return arrYear.join(' - ')
    }
  },
  getDateRangeOutput (dateInput) {
    if (typeof dateInput === 'string' && dateInput.trim() !== '') {
      let arrDate = dateInput.split('-')
      for (let i in arrDate) {
        arrDate[i] = this.getDateOutput(arrDate[i].trim())
      }
      return arrDate.join(' - ')
    }
    return dateInput
  },
  getDateTimeRangeOutput (dateInput) {
    if (typeof dateInput === 'string' && dateInput.trim() !== '') {
      let arrDate = dateInput.split('-')
      for (let i in arrDate) {
        let date = arrDate[i].trim()
        if (date.replace(/\//g, '').length === 8) {
          arrDate[i] = this.getDateOutput(arrDate[i].trim())
        } else {
          arrDate[i] = this.getDateTimeOutput(arrDate[i].trim())
        }
      }
      return arrDate.join(' - ')
    }
    return dateInput
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js